"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFileTable = void 0;
const file_table_1 = require("../../file-table/file-table");
const form_field_1 = require("./form-field");
exports.FormFileTable = form_field_1.formFieldFactory(file_table_1.FileTable);
//# sourceMappingURL=form-file-table.js.map